module.exports = __webpack_public_path__ + "img/g_mro_7.784402e4.png";